import { FC, useEffect, useState } from 'react'
import { RenderIf } from 'components/RenderIf'
import { Button } from 'featureSliced/entities/Button'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { AmountHandler } from 'featureSliced/widgets/AmountHandler'

import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'
import { TableStatuses } from 'featureSliced/shared/store/reducers/QRMenuTableReducer/types'

import { Divider, FooterContainer } from '../ComonProduct/styled'
import {
  IBucketProduct,
  IProductWithBucketProduct,
} from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

type UpdateProductFooterProps = {
  product: IProductWithBucketProduct
  bucketProduct: IBucketProduct
  closeProduct: () => void
  currentAmount: number
  setCurrentAmount: (value: number) => void
}

export const UpdateProductFooter: FC<UpdateProductFooterProps> = ({
  product,
  bucketProduct,
  closeProduct,
  currentAmount,
  setCurrentAmount,
}) => {
  // Hooks
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const addProductToBucket = QRMBucketSlice.actions.addProductToBucket

  // Store
  const tableStatus = useMySelector((state) => state.qrMenuTable.tableStatus)
  const bookingVariant = useMySelector((state) => state.app.menu.bookingVariant)
  const disabledByMobileWaiter = useMySelector(
    (state) => state.app.menu.disabledByMobileWaiter
  )

  // Functions
  const getMultiplier = (sellCode: number | null) => {
    if (sellCode === 2) {
      return 100
    } else {
      return 1
    }
  }

  const getStep = (sellCode: number | null) => {
    if (sellCode === 3) {
      return 0.1
    } else {
      return 1
    }
  }

  const updateProduct = () => {
    const productToAdd = {
      ...bucketProduct,
      count: currentAmount,
    }
    dispatch(addProductToBucket(productToAdd))
    closeProduct()
  }

  return (
    <RenderIf
      key={`${navigator.onLine}${bookingVariant}${disabledByMobileWaiter}${tableStatus}`}
      condition={
        navigator.onLine &&
        (process.env.REACT_APP_IS_CLIC === '1' ||
          (bookingVariant === 2 &&
            !disabledByMobileWaiter &&
            tableStatus !== TableStatuses.BUSY))
      }
    >
      <Divider />
      <FooterContainer>
        <AmountHandler
          multiplier={getMultiplier(product.unitSellCode)}
          step={getStep(product.unitSellCode)}
          currentValue={currentAmount}
          onDecrease={setCurrentAmount}
          onIncrease={setCurrentAmount}
        />
        <Button
          buttonType="common"
          disabled={tableStatus === TableStatuses.BUSY}
          width="100%"
          onClick={updateProduct}
        >
          {t('buttons.update')}
        </Button>
      </FooterContainer>
    </RenderIf>
  )
}
